import { Pagination } from "@heroui/react";

interface OrdersPaginationProps {
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
}

export function OrdersPagination({ page, pages, onPageChange }: Readonly<OrdersPaginationProps>) {
  return (
    <div className="py-2 px-2 flex justify-between items-center">
      <Pagination
        showControls
        isCompact
        page={page}
        total={pages}
        variant="light"
        onChange={onPageChange}
      />
    </div>
  );
};

export default OrdersPagination;
